import { render, staticRenderFns } from "./painel-bill-list.vue?vue&type=template&id=4abb8ee6&"
import script from "./painel-bill-list.vue?vue&type=script&lang=js&"
export * from "./painel-bill-list.vue?vue&type=script&lang=js&"
import style0 from "./painel-bill-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports